// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stryder-stationery-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: Poppins;
}

.stryder-stationery-background {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  z-index: -1;
  pointer-events: none;
}

.stryder-stationery-header {
  padding: 16px 64px;
  line-height: 1em;
  background: rgb(0, 142, 211);
}

.stryder-stationery-header .screen-small {
  display: none;
}

@media (max-width: 540px) {
  .stryder-stationery-header .screen-full {
    display: none;
  }
  .stryder-stationery-header .screen-small {
    display: unset;
  }

  .stryder-stationery-header .header-logo {
    max-width: calc(100% - 20px);
  }
}

.stryder-stationery-description {
  margin-bottom: 40px;
}

.stryder-stationery-scroll {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.stryder-stationery-content {
  margin: 0 auto;
  padding: 8px;
  max-width: 680px;
}

.stryder-stationery-title {
  margin: 16px !important;
  /* color: #3e8ccd; */
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/Stryder/components/Stationery/stryder-stationery.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;AACnB","sourcesContent":[".stryder-stationery-root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  font-family: Poppins;\n}\n\n.stryder-stationery-background {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.stryder-stationery-header {\n  padding: 16px 64px;\n  line-height: 1em;\n  background: rgb(0, 142, 211);\n}\n\n.stryder-stationery-header .screen-small {\n  display: none;\n}\n\n@media (max-width: 540px) {\n  .stryder-stationery-header .screen-full {\n    display: none;\n  }\n  .stryder-stationery-header .screen-small {\n    display: unset;\n  }\n\n  .stryder-stationery-header .header-logo {\n    max-width: calc(100% - 20px);\n  }\n}\n\n.stryder-stationery-description {\n  margin-bottom: 40px;\n}\n\n.stryder-stationery-scroll {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n}\n.stryder-stationery-content {\n  margin: 0 auto;\n  padding: 8px;\n  max-width: 680px;\n}\n\n.stryder-stationery-title {\n  margin: 16px !important;\n  /* color: #3e8ccd; */\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
